import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "whitespace-nowrap text-xs font-semibold text-gray-500" }, "Se não atender:", -1)

import SegmentedControl from '@/components/designSystem/SegmentedControl/SegmentedControl.vue'
import type { QualificationOnFail } from '@/types/qualification-eligibility.types'

import { ON_FAIL_OPTIONS } from './policyModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnFailSelector',
  props: {
    modelValue: {},
    testId: { default: 'qualification-on-fail' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {




// O SegmentedControl só oferece as opções de `ON_FAIL_OPTIONS`.
const onChange = (value: string) => emit('update:modelValue', value as QualificationOnFail)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SegmentedControl, {
      "model-value": _ctx.modelValue,
      options: _unref(ON_FAIL_OPTIONS),
      ariaLabel: "O que fazer se o médico não atender",
      size: "sm",
      "test-id": _ctx.testId,
      "onUpdate:modelValue": onChange
    }, null, 8, ["model-value", "options", "test-id"])
  ]))
}
}

})